const pickerKeys = {
  DATE: "showDatePicker",
  END_DATE: "showEndDatePicker",
  TIME: "showTimePicker",
  END_TIME: "showEndTimePicker",
  DURATION: "showDurationPicker",
}

export default pickerKeys
